const getGlobalHeaders = () => ({
  'credentials': 'same-origin',
  'app-type': window.CUEMATH_APP_TYPE || 'LEAP',
});

export default getGlobalHeaders;
